var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReddit = function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23024D",
    d: "M18 8.12a1.974 1.974 0 0 0-3.338-1.352A9.6 9.6 0 0 0 9.46 5.106l.878-4.218 2.892.609a1.352 1.352 0 1 0 .175-.825L10.095.01a.42.42 0 0 0-.5.324l-1 4.69a9.65 9.65 0 0 0-5.27 1.663 1.973 1.973 0 1 0-2.176 3.23 4 4 0 0 0 0 .595C1.15 13.54 4.676 16 9.027 16s7.878-2.46 7.878-5.488a4 4 0 0 0 0-.595A1.97 1.97 0 0 0 18 8.12M4.487 9.47a1.352 1.352 0 1 1 2.704 0 1.352 1.352 0 0 1-2.704 0m7.85 3.717A5.2 5.2 0 0 1 9 14.23a5.2 5.2 0 0 1-3.337-1.04.365.365 0 0 1 .513-.514 4.42 4.42 0 0 0 2.81.851 4.43 4.43 0 0 0 2.825-.824.378.378 0 0 1 .527.54zm-.242-2.31a1.351 1.351 0 1 1 1.35-1.353 1.35 1.35 0 0 1-1.364 1.406z"
  })));
};
export default SvgReddit;